import { createContext, useContext } from "react";
export const WorkNavigationContext = createContext([]);
export const useWorkNavigation = () => useContext(WorkNavigationContext);
